import React from 'react';
import { NavLink } from 'react-router-dom';

const CompareColleges = () => {
    return (
        <div className="bg-gray-50 min-h-screen pb-20">
            {/* Banner Section */}
            <div className="bg-gradient-to-r from-green-900 via-green-800 to-green-900 text-white py-20 text-center shadow-lg relative overflow-hidden">
                <div className="absolute inset-0 bg-green-500 opacity-10 pattern-grid-lg"></div>
                <div className="container mx-auto px-4 relative z-10">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4">Compare Colleges</h1>
                    <p className="text-gray-200 max-w-2xl mx-auto text-lg">
                        Compare fees, placements, rankings, and courses side by side to make the best decision for your career.
                    </p>
                </div>
            </div>

            {/* Main Content */}
            <div className="container mx-auto px-4 mt-12">
                <div className="bg-white rounded-3xl shadow-xl border border-gray-200 p-8">
                    <div className="text-center py-16">
                        <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6">
                            <i className="fa fa-balance-scale text-3xl text-green-600"></i>
                        </div>
                        <h2 className="text-2xl font-bold text-gray-800 mb-2">Comparison Tool Coming Soon</h2>
                        <p className="text-gray-500 max-w-md mx-auto mb-8">
                            We are building a comprehensive comparison tool to help you evaluate colleges matching your preferences.
                        </p>
                        <NavLink to="/TopUniversitiesandColleges" className="inline-block bg-green-600 text-white font-bold py-3 px-8 rounded-full hover:bg-green-700 transition shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                            Explore Top Colleges
                        </NavLink>
                    </div>

                    {/* Placeholder for Comparison Grid (Mockup for Visual) */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 opacity-50 blur-[1px] select-none pointer-events-none">
                        <div className="border border-gray-200 rounded-2xl p-6">
                            <div className="h-40 bg-gray-100 rounded-xl mb-4"></div>
                            <div className="h-6 bg-gray-100 rounded mb-2 w-3/4"></div>
                            <div className="h-4 bg-gray-100 rounded w-1/2"></div>
                        </div>
                        <div className="border border-gray-200 rounded-2xl p-6">
                            <div className="h-40 bg-gray-100 rounded-xl mb-4"></div>
                            <div className="h-6 bg-gray-100 rounded mb-2 w-3/4"></div>
                            <div className="h-4 bg-gray-100 rounded w-1/2"></div>
                        </div>
                        <div className="border border-gray-200 rounded-2xl p-6 flex items-center justify-center bg-gray-50">
                            <span className="text-gray-400 font-bold border-2 border-dashed border-gray-300 p-4 rounded-xl">Add College</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompareColleges;
